import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Announcement from "./Announcement";
import NumberFormat from "react-number-format";
import EminevimLoading from "../shared/EminevimLoading";
import {
  getDashboardInfo,
  selectDashboardInfo,
} from "../../../state/ducks/dashboard/index";

class Dashboard extends Component {
  state = {
    isLoading: true,
    shouldAnimate: false,
  };

  componentDidMount() {
    this._isMounted = true;
    this._animateTimer = null;

    this.props
      .getDashboardInfo()
      .finally(() => {
        if (!this._isMounted) return;

        this.setState({ isLoading: false, shouldAnimate: true });
        this._animateTimer = window.setTimeout(() => {
          if (this._isMounted) {
            this.setState({ shouldAnimate: false });
          }
        }, 1200);
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._animateTimer) {
      window.clearTimeout(this._animateTimer);
    }
  }

  renderOverviewPanel = () => {
    const { login, dashboardInfo, isCandidateCustomer } = this.props;
    const { shouldAnimate } = this.state;
    const username = login?.info?.username || "";
    const debt = dashboardInfo?.debt || {};
    const hasTutar = debt.tutar !== 0;
    const hasAltin = debt.altin !== 0;
    const noDebt = !hasTutar && !hasAltin;
    const anyActiveMember = dashboardInfo?.anyActiveMember;
    const showDebt = !isCandidateCustomer;

    return (
      <section
        className={`t-dashboardOverview t-dashboardGlass${shouldAnimate ? " t-dashboardOverview--enter" : ""
          }`}
      >
        <div className="t-dashboardOverviewWelcome">
          <span className="t-dashboardOverviewEyebrow">Eminevim İnternet Şube</span>
          <h1 className="t-dashboardOverviewTitle">
            <span className="t-dashboardOverviewHello">Hoş Geldiniz</span><br />
            {username ? ` ${username}` : ""}
          </h1>
          <p className="t-dashboardOverviewLead">
            Hesabınıza genel bakış, hızlı işlemler ve güncel duyurular tek ekranda.
          </p>
          <div className="t-dashboardOverviewMeta">
            <span>
              <i className="t-icon-calendar" aria-hidden="true" />
              Son Giriş: <strong>{login?.info?.lastLoginDate || "-"}</strong>
            </span>
            <span>
              <i className="t-icon-world" aria-hidden="true" />
              IP: <strong>{login?.info?.lastIpAddress || "-"}</strong>
            </span>
          </div>
        </div>

        {showDebt && (
          <>
            <div className="t-dashboardOverviewDivider" aria-hidden="true" />
            <div className="t-dashboardOverviewDebt">
              <div className="t-dashboardOverviewDebtHead">
                <div className="t-dashboardOverviewDebtIcon" aria-hidden="true">
                  <i className="t-icon-wallet" />
                </div>
                <div>
                  <span className="t-dashboardOverviewDebtLabel">Ödeme Özeti</span>
                  {anyActiveMember && !noDebt && (
                    <span className="t-dashboardOverviewDebtDate">{debt.tarih}</span>
                  )}
                </div>
              </div>

              {anyActiveMember ? (
                <>
                  <div className="t-dashboardOverviewAmounts">
                    {hasTutar && (
                      <div className="t-dashboardOverviewAmount">
                        <NumberFormat
                          decimalSeparator=","
                          thousandSeparator="."
                          value={debt.tutar}
                          displayType="text"
                        />
                        <span className="t-dashboardOverviewCurrency">₺</span>
                        {hasAltin && <span className="t-dashboardOverviewPlus">+</span>}
                      </div>
                    )}
                    {hasAltin && (
                      <div className="t-dashboardOverviewAmount t-dashboardOverviewAmount--gold">
                        <NumberFormat
                          decimalSeparator=","
                          thousandSeparator="."
                          value={debt.altin}
                          displayType="text"
                        />
                        <span className="t-dashboardOverviewCurrency">XAU</span>
                      </div>
                    )}
                  </div>

                  <p className="t-dashboardOverviewDebtNote">
                    {noDebt ? (
                      <>
                        <strong>{debt.tarih}</strong> itibarıyla{" "}
                        <span className="t-dashboardOverviewHighlight">Borcunuz Yoktur</span>
                      </>
                    ) : (
                      "Ödenecek Toplam Tutar"
                    )}
                  </p>
                </>
              ) : (
                <p className="t-dashboardOverviewDebtNote">
                  <span className="t-dashboardOverviewHighlight">
                    Aktif Üyeliğiniz Bulunmamaktadır
                  </span>
                </p>
              )}

              <Link to="/Home/MemberInfo" className="t-dashboardOverviewLink">
                Detay İçin Tıklayınız
                <i className="t-icon-arrow-right1" aria-hidden="true" />
              </Link>
            </div>
          </>
        )}
      </section>
    );
  };

  getQuickActions = () => {
    const { dashboardInfo } = this.props;
    const videoLink = dashboardInfo?.videoLink;
    const hasLiveStream = Boolean(videoLink && videoLink.id !== 0);
    const actions = [];

    if (dashboardInfo?.hiddenMenu?.showPaymentOrder) {
      actions.push({
        key: "createpayment",
        to: "/Home/CreatePayment",
        external: false,
        icon: "t-icon-clipboard",
        title: "Talimat Ver",
        subtitle: "Ödeme talımatı verin",
      });
    }

    if (dashboardInfo?.isShowMemberApplication) {
      actions.push({
        key: "calculation",
        to: "/Home/SmartCalculation",
        external: false,
        icon: "t-icon-calculator",
        title: "Hesaplama Yap",
        subtitle: "Kampanya ve taksit planı",
      });
    }

    actions.push(
      {
        key: "live",
        to: hasLiveStream ? `/Home/AnnouncementDetail/${videoLink.id}` : "/Home/Dashboard",
        external: false,
        icon: "t-icon-connected_tv",
        title: "Canlı Yayın",
        subtitle: hasLiveStream ? "Canlı izleyin" : "Yayın yok",
        isLive: hasLiveStream,
      },
      {
        key: "branches",
        href: "https://www.eminevim.com/subeler",
        external: true,
        icon: "t-icon-home",
        title: "Şubelerimiz",
        subtitle: "En yakın şube",
      },
      {
        key: "bank",
        href: "https://www.eminevim.com/banka-hesap-numaralarimiz",
        external: true,
        icon: "t-icon-library",
        title: "Banka Bilgileri",
        subtitle: "Hesap numaraları",
      },
      {
        key: "faq",
        to: "/Home/Questions",
        external: false,
        icon: "t-icon-question1",
        title: "SSS",
        subtitle: "Sık sorulan sorular",
      }
    );

    return actions;
  };

  renderQuickActionCard = (action, index) => {
    const { shouldAnimate } = this.state;
    const cardClassName = [
      "t-dashboardTile",
      action.isLive ? "t-dashboardTile--live" : "",
      shouldAnimate ? "t-dashboardTile--enter" : "",
    ]
      .filter(Boolean)
      .join(" ");

    const content = (
      <>
        <div className="t-dashboardTileIcon">
          <i className={action.icon} aria-hidden="true" />
          {action.isLive && <span className="t-dashboardTileLiveDot" aria-hidden="true" />}
        </div>
        <strong className="t-dashboardTileTitle">{action.title}</strong>
        <span className="t-dashboardTileSubtitle">{action.subtitle}</span>
      </>
    );

    const style = shouldAnimate ? { animationDelay: `${index * 60}ms` } : undefined;

    if (action.external) {
      return (
        <a
          key={action.key}
          href={action.href}
          target="_blank"
          rel="noopener noreferrer"
          className={cardClassName}
          style={style}
        >
          {content}
        </a>
      );
    }

    return (
      <Link key={action.key} to={action.to} className={cardClassName} style={style}>
        {content}
      </Link>
    );
  };

  renderShortcuts = () => {
    const links = [
      { to: "/Home/AccountInfo", icon: "t-icon-info_outline", label: "Bilgilerim" },
      { to: "/Home/AgentInfo", icon: "t-icon-user-tie", label: "Temsilci Bilgilerim" },
      { to: "/Home/AskToAgent", icon: "t-icon-chat-alt-stroke", label: "Temsilcime Soru Sor" },
    ];

    return (
      <nav className="t-dashboardShortcuts t-dashboardGlass" aria-label="Hızlı erişim">
        {links.map((link) => (
          <Link key={link.to} to={link.to} className="t-dashboardShortcut">
            <i className={link.icon} aria-hidden="true" />
            <span>{link.label}</span>
          </Link>
        ))}
      </nav>
    );
  };

  render() {
    const { dashboardInfo } = this.props;
    const { isLoading } = this.state;
    const quickActions = this.getQuickActions();

    return (
      <div className="t-dashboardPage">
        <div className="row t-dashboardPageInner">
          <div className="col-12">
            {isLoading ? (
              <div className="t-dashboardLoading">
                <EminevimLoading subtext="FAİZSİZ EV ALMA SİSTEMİNİN MUCİDİ" />
              </div>
            ) : (
              <>
                {this.renderOverviewPanel()}

                <section className="t-dashboardBlock" aria-label="Hızlı işlemler">
                  <header className="t-dashboardBlockHead">
                    <h2 className="t-dashboardQuickTitle">Hızlı İşlemler</h2>
                    <p>Sık kullandığınız işlemlere tek dokunuşla ulaşın</p>
                  </header>
                  <div className="t-dashboardTileGrid">
                    {quickActions.map((action, index) =>
                      this.renderQuickActionCard(action, index)
                    )}
                  </div>
                </section>

                {this.renderShortcuts()}

                {dashboardInfo?.announcements?.length > 0 && (
                  <Announcement duyurular={dashboardInfo.announcements} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dashboardInfo: selectDashboardInfo(state),
  isCandidateCustomer: state.dashboard.isCandidateCustomer,
});

const mapDispatchToProps = (dispatch) => ({
  getDashboardInfo: () => dispatch(getDashboardInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
